'use client'

import React, { createContext, useContext } from 'react'

interface MobileContextProps {
  isMobile: boolean
}

interface MobileProviderProps {
  children: React.ReactNode
  isMobile: boolean
}

const MobileContext = createContext<MobileContextProps>({
  isMobile: false,
})

export const MobileProvider = ({ isMobile, children }: MobileProviderProps) => {
  return (
    <MobileContext.Provider value={{ isMobile }}>
      {children}
    </MobileContext.Provider>
  )
}

export const useMobileContext = () => useContext(MobileContext)
